import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from 'react-redux';
import {
  removeServiceFromCart,
  clearCart,
  increaseQuantity,
  decreaseQuantity,
} from '../../redux/cartSlice';







import ViewCartComponent from "../cart/ViewCartComponent";

const CartComponent = () => {
  const [cartList, setCartList] = useState(false);

  const [confirmForm, setConfirmForm] = useState(false);

  // --------------------------------------------------------------------------------------------

  const cart = useSelector(state => state.cart.services);
 



  return (
    <div>
   
   
      {cart.length <= 0 ? (
        ""
      ) : (
        <div className="cart-fix-col">
          <div
            className="cart-fix-col-text"
            onClick={(e) => setCartList(!cartList)}
          >
            Total Amount : <span> Rs. { cart.reduce( (acc, e) => {
              return acc + Number(e.discountedPrice * e.quantity)
            }, 0 )} /-</span>
          </div>
          <div
            className="cart-fix-button"
            onClick={(e) => setCartList(!cartList)}
          >
            <div>{cart.length}</div>
            <i className="fa-solid fa-cart-shopping"></i>
          </div>
        </div>
      )}

      {/* ------------------------------------------------------------- */}

      {
      // cartList ? 
      cart.length > 0 && cartList ?
      (
        <ViewCartComponent
          setCartList={setCartList}
          cart={cart}
          
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default CartComponent;
